var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBox = function SvgBox(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "512px",
    id: "Tracking_x5F_number",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "184.044,103.688 173.17,103.688 166.546,114.468 159.83,103.688 148.866,103.688 160.77,122.094 147.674,142.068    158.881,142.068 166.417,130.332 173.971,142.068 185.221,142.068 172.147,122.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.044,103.938 129.17,103.938 122.546,114.718 115.83,103.938 104.866,103.938 116.77,122.344 103.674,142.318    114.881,142.318 122.417,130.582 129.971,142.318 141.221,142.318 128.147,122.571  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.72,142.068 276.97,142.068 263.896,122.321 275.793,103.688 264.919,103.688 258.295,114.468 251.579,103.688    240.615,103.688 252.519,122.094 239.423,142.068 250.63,142.068 258.166,130.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.96,103.688 84.085,103.688 77.461,114.468 70.744,103.688 59.781,103.688 71.686,122.094 58.59,142.068    69.797,142.068 77.333,130.332 84.886,142.068 96.137,142.068 83.063,122.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.293,103.688 219.419,103.688 212.795,114.468 206.079,103.688 195.115,103.688 207.019,122.094    193.923,142.068 205.13,142.068 212.666,130.332 220.22,142.068 231.47,142.068 218.396,122.321  "
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 61.241,
    x: 138.909,
    y: 368.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 61.241,
    x: 138.909,
    y: 387.078
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 18.182,
    x: 22.639,
    y: 417.046
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 18.182,
    x: 471.18,
    y: 417.046
  }), /*#__PURE__*/React.createElement("rect", {
    height: 13.671,
    width: 10,
    x: 114.362,
    y: 185.102
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.362,211.225 114.362,211.225 114.362,417.046 54.026,417.046 54.026,427.046 114.362,427.046 119.362,427.046    360.742,427.046 360.742,417.046 124.362,417.046  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.994,128.65 322.193,128.65 322.193,138.65 412.994,138.65 412.994,417.046 392.638,417.046 392.638,417.05    374.464,417.05 374.464,427.05 422.994,427.05 422.994,427.046 457.974,427.046 457.974,417.046 422.994,417.046  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.363,172.561h10v-9.852h128.369l56.354,48.864V84.95H28.985v77.759h85.378V172.561z M38.985,152.709V94.95h260.102   v94.716l-42.622-36.958H38.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.015,304.9H318.47v84.545h84.545V304.9z M393.015,379.445H328.47V314.9h64.545V379.445z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 40.922,
    x: 340.281,
    y: 329.788
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    width: 40.922,
    x: 340.281,
    y: 346.301
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 10,
    x: 243.926,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 10,
    x: 393.015,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 8,
    x: 304.516,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 10,
    x: 360.899,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 10,
    x: 339.315,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 385.983,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 379.703,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 353.607,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 332.089,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 321.97,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 267.83,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 260.498,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 3,
    x: 296.317,
    y: 222.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 48.887,
    width: 10,
    x: 279.448,
    y: 222.527
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/box.d831c2bf.svg";
export { ForwardRef as ReactComponent };